@for (message of messages; track message) {
  <div class="message-container">
    <rc-alert
      [customIcon]="message.customIcon"
      [showCloseAction]="message.hideCloseAction !== true"
      [type]="message.type"
      (closeAlert)="closeAlertById(message.id)"
    >
      {{ message?.text || (message?.keyTrad || '' | translate) }}
    </rc-alert>
  </div>
}
